import { FluidForm } from "./FluidForm";
export function buildFormConfigOptions(options) {
    return {
        form: options.form,
        slack: options.slack,
        getStream: options.getStream,
    };
}
export class FormConfigOptions {
    mode;
    options;
    constructor(mode, options) {
        this.mode = mode;
        this.options = options;
        this.options = buildFormConfigOptions(options);
    }
    getConfig() {
        return this.options[this.mode];
    }
}
export function buildFluidForm(formConfigRecord, data) {
    return new FluidForm(formConfigRecord.formConfig, data, {
        actionsConfig: formConfigRecord.actionsConfig,
        styleConfig: formConfigRecord.styleConfig
    });
}
